import * as s from './CalendarHeatmapCell.css';

/** 기간 색 — 기간마다 차례로 돌려 쓴다. 날짜 상세의 색 표시도 같은 색을 쓴다 */
export const SCHEDULE_SPAN_TONE_COUNT = s.spanTones.length;
export function scheduleSpanToneClass(tone: number): string {
  return s.spanTones[tone % s.spanTones.length] ?? '';
}
